/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, type ErrorInfo, type ReactNode } from 'react';

import { logToSentry } from '@jsmdg/react-fragment-scripts/fragment';

type ErrorBoundaryProps = {
    readonly children: ReactNode;
    readonly fallback?: ReactNode | null;
};

type ErrorBoundaryState = {
    hasError: boolean;
};

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    // eslint-disable-next-line react/sort-comp
    public constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    public static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        logToSentry(error);
    }

    public render(): ReactNode | null {
        const { hasError } = this.state;
        const { children, fallback = null } = this.props;

        if (hasError) {
            return fallback;
        }

        return children;
    }
}

export { ErrorBoundary };
